<div class="voucher-container">
  <div class="voucher-details">
    <h4 class="d-flex justify-content-lg-start justify-content-center">{{ 'voucher.title' | translate }}</h4>

    <p>{{ 'voucher.description' | translate }}</p>

    <div class="voucher-input-group">
      <input
        type="text"
        [(ngModel)]="voucherCode"
        aria-labelledby="voucher-label"
        placeholder="Enter code"
        class="code-input bg-glass border-0"
        (keyup.enter)="redeemVoucher()"
      />

      <button class="apply-btn" (click)="redeemVoucher()" [disabled]="disableButton">
        {{ 'voucher.apply' | translate }}
      </button>
    </div>
  </div>
  <img [src]="'placeholders/voucher.svg' | contentAssetImage" alt="voucher image" class="voucher-image d-none d-md-block" />
  <img [src]="'placeholders/vouchermobile.svg' | contentAssetImage" alt="voucher image" class="d-md-none w-100" />

  <ngb-toast
    *ngFor="let toast of toastService.toasts"
    [class]="toast.classname"
    [autohide]="true"
    [delay]="10000"
    (hidden)="toastService.remove(toast)"
  >
    <div class="toast-details">
      <span class="material-icons text-success" *ngIf="toast.type === 'success'">check_circle</span>
      <span class="material-icons text-error" *ngIf="toast.type === 'fail'">cancel</span>
      <span class="material-icons text-secondary" *ngIf="toast.type === 'notvalid'">cancel</span>

      <span
        [ngClass]="{
          'text-success': toast.type === 'success',
          'text-error': toast.type === 'fail',
          'text-secondary': toast.type === 'notvalid',
        }"
        class="fw-bold font-size-14"
      >
        {{ toast.textOrTpl }}
      </span>
    </div>
  </ngb-toast>
</div>
